// import { useEffect, useState } from "react";
// import Button from "../common/Button";
// import { getAllSubjects } from "../../services/subjectService";

// const SubjectForm = ({
//   onSubmit,
//   onCancel,
//   initial = {},
//   loading = false,
//   step,
// }) => {
//   // Accept both possible initial shapes: id or SubjectID
//   const [subjectId] = useState(
//     initial.id ?? initial.SubjectID ?? initial.subjectId ?? ""
//   );
//   const [name, setName] = useState(
//     initial.name || initial.subjectName || initial.SubjectName || ""
//   );
//   const [subjectCode, setSubjectCode] = useState(
//     initial.subjectCode || initial.SubjectCode || ""
//   );
//   const [description, setDescription] = useState(
//     initial.description || initial.Description || ""
//   );
//   const [descriptionError, setDescriptionError] = useState("");

//   const [formError, setFormError] = useState("");
//   const [checking, setChecking] = useState(false);
//   const [subjectCodeError, setSubjectCodeError] = useState("");
//   const [codeManuallyEdited, setCodeManuallyEdited] = useState(
//     Boolean(initial.subjectCode || initial.SubjectCode)
//   );
//   const [autoGeneratedCode, setAutoGeneratedCode] = useState("");

//   const generateSubjectCode = (subjectName = "") => {
//     const trimmed = subjectName.replace(/[^a-zA-Z]/g, "").toUpperCase();
//     const prefix = trimmed.slice(0, 3);
//     if (!prefix) return "";
//     const hash = Array.from(subjectName).reduce(
//       (acc, char, index) => acc + char.charCodeAt(0) * (index + 1),
//       0
//     );
//     const numericPart = String(hash % 1000).padStart(3, "0");
//     return `${prefix}${numericPart}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setFormError("");
//     setDescriptionError("");
//     setSubjectCodeError("");
//     const trimmedName = name.trim();
//     const trimmedCode = subjectCode.trim();
//     const trimmedDescription = description.trim();

//     // Validate both fields and show both errors at once if missing
//     let hasError = false;
//     if (!trimmedName) {
//       setFormError("Class name is required");
//       hasError = true;
//     }
//     if (!trimmedCode) {
//       setSubjectCodeError("Class code is required");
//       hasError = true;
//     }
//     // enforce format: uppercase alnum, dash or underscore, 2-20 chars
//     if (trimmedCode && !/^[A-Z0-9_-]{2,20}$/.test(trimmedCode)) {
//       setSubjectCodeError(
//         "Class code must be 2–20 alphanumeric characters (no spaces)"
//       );
//       hasError = true;
//     }
//     if (trimmedDescription.length > 500) {
//       setDescriptionError("Description must be 500 characters or less.");
//       hasError = true;
//     }
//     if (hasError) return;

//     // build payload including both common keys to improve backend compatibility
//     const payload = {
//       // include id when editing (cover multiple naming conventions)
//       ...(subjectId
//         ? {
//             id: subjectId,
//             SubjectID: subjectId,
//             subjectId: subjectId,
//           }
//         : {}),
//       name: trimmedName,
//       subjectName: trimmedName,
//       SubjectName: trimmedName,
//       subjectCode: trimmedCode,
//       SubjectCode: trimmedCode,
//       description: trimmedDescription,
//       Description: trimmedDescription,
//       // include courseName if provided initially so duplicate checks can scope to a course
//       ...(initial.courseName
//         ? {
//             courseName: initial.courseName,
//             CourseName: initial.courseName,
//           }
//         : {}),
//     };

//     // Prevent adding the same subject to the same course
//     setChecking(true);
//     try {
//       const subjects = await getAllSubjects();
//       const lowerName = trimmedName.toLowerCase();
//       const courseName = (initial.courseName || "")
//         .toString()
//         .trim()
//         .toLowerCase();

//       const lowerCode = trimmedCode.toLowerCase();
//       const duplicate = subjects.find((s) => {
//         const sName = (s.name || s.subjectName || "")
//           .toString()
//           .trim()
//           .toLowerCase();
//         const sCode = (s.code || s.subjectCode || "")
//           .toString()
//           .trim()
//           .toLowerCase();
//         const sCourse = (s.courseName || "").toString().trim().toLowerCase();
//         // consider duplicate if name or code matches within same course scope (if provided)
//         if (courseName) {
//           return (
//             (sName === lowerName && sCourse === courseName) ||
//             (sCode && sCode === lowerCode && sCourse === courseName)
//           );
//         }
//         return sName === lowerName || (sCode && sCode === lowerCode);
//       });

//       if (duplicate) {
//         // allow edit of the same record (same id)
//         const dupId =
//           duplicate.id ?? duplicate.SubjectID ?? duplicate.subjectId ?? "";
//         if (subjectId && String(dupId) === String(subjectId)) {
//           // it's the same record; allow
//         } else {
//           // prefer a code-specific message if codes match
//           const dupCode = (duplicate.code ?? duplicate.subjectCode ?? "")
//             .toString()
//             .trim()
//             .toLowerCase();
//           if (dupCode && dupCode === trimmedCode.toLowerCase()) {
//             setFormError(
//               courseName
//                 ? "A class with this code already exists for the selected course."
//                 : "A class with this code already exists."
//             );
//           } else {
//             setFormError(
//               courseName
//                 ? "This class already exists for the selected course."
//                 : "A class with this name already exists."
//             );
//           }
//           setChecking(false);
//           return;
//         }
//       }
//     } catch (err) {
//       // If subject list fetch fails, allow submission but warn in console
//       console.warn("Could not validate duplicates from backend:", err);
//     } finally {
//       setChecking(false);
//     }

//     onSubmit(payload);
//   };

//   useEffect(() => {
//     if (initial.subjectCode || initial.SubjectCode) {
//       setCodeManuallyEdited(true);
//       return;
//     }
//     if (codeManuallyEdited) return;
//     if (!name) {
//       if (autoGeneratedCode) {
//         setAutoGeneratedCode("");
//         setSubjectCode("");
//       }
//       return;
//     }

//     const generated = generateSubjectCode(name);
//     if (!generated || generated === autoGeneratedCode) return;
//     setAutoGeneratedCode(generated);
//     setSubjectCode(generated);
//   }, [
//     name,
//     codeManuallyEdited,
//     autoGeneratedCode,
//     initial.subjectCode,
//     initial.SubjectCode,
//   ]);

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       {step ? (
//         <div className="text-sm font-medium text-indigo-600">
//           Step {step} of 2
//         </div>
//       ) : null}

//       <div>
//         <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
//           Class Code <span className="text-red-500">*</span>
//         </label>
//         <input
//           disabled
//           value={subjectCode}
//           onChange={(e) => {
//             // normalize to uppercase and clear code errors
//             const upper = String(e.target.value || "")
//               .toUpperCase()
//               .replace(/\s+/g, "");
//             setSubjectCode(upper);
//             setSubjectCodeError("");
//             setCodeManuallyEdited(true);
//           }}
//           placeholder="e.g. WAT818"
//           className="mt-1 block w-full rounded-md dark:bg-gray-700  border-gray-300 p-2"
//         />
//         {subjectCodeError ? (
//           <p className="mt-1 text-sm text-red-600">{subjectCodeError}</p>
//         ) : null}
//       </div>

//       <div>
//         <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
//           Class Name <span className="text-red-500">*</span>
//         </label>
//         <input
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder="e.g. Wattala Class-Mon"
//           className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
//         />
//         {formError ? (
//           <p className="mt-1 text-sm text-red-600">{formError}</p>
//         ) : null}
//       </div>

//       <div>
//         <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
//           Description
//         </label>
//         <textarea
//           value={description}
//           onChange={(e) => setDescription(e.target.value)}
//           className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
//           placeholder="Brief description (optional)"
//         />
//         {descriptionError ? (
//           <p className="mt-1 text-sm text-red-600">{descriptionError}</p>
//         ) : null}
//       </div>

//       <div className="flex flex-wrap justify-end gap-2">
//         <Button
//           type="button"
//           variant="secondary"
//           onClick={onCancel}
//           disabled={loading || checking}
//         >
//           Cancel
//         </Button>
//         <Button type="button" variant="primary" disabled={loading || checking} onClick={handleSubmit}>
//           {loading || checking ? "Saving..." : "Save"}
//         </Button>
//       </div>
//     </form>
//   );
// };

// export default SubjectForm;
import { useEffect, useState } from "react";
import Button from "../common/Button";
import CustomSelect from "../common/CustomSelect";
import Modal from "../common/Modal2";
import CourseForm from "../courses/CourseForm";
import { getAllSubjects, getAllSubjectsIncludingInactive } from "../../services/subjectService";
import { getAllCourses, createCourse } from "../../services/courseService";
import TeacherPicker from "../common/TeacherPicker";
import { FiUsers, FiChevronRight, FiBook } from "react-icons/fi";

const SubjectForm = ({
  onSubmit,
  onCancel,
  initial = {},
  loading = false,
  step,
  hideCourseField = false,
}) => {
  // Accept both possible initial shapes: id or SubjectID
  const [subjectId] = useState(
    initial.id ?? initial.SubjectID ?? initial.subjectId ?? ""
  );
  const [name, setName] = useState(
    initial.name || initial.subjectName || initial.SubjectName || ""
  );
  const [subjectCode, setSubjectCode] = useState(
    initial.subjectCode || initial.SubjectCode || ""
  );
  const [description, setDescription] = useState(
    initial.description || initial.Description || ""
  );
  const [fee, setFee] = useState(
    (() => {
      const v = initial.fee ?? initial.Fee ?? initial.subjectFee ?? initial.SubjectFee ?? "";
      if (v === null || v === undefined || v === "") return "";
      const s = String(v).replace(/,/g, "");
      const n = Number(s);
      if (Number.isNaN(n)) return String(v);
      return n % 1 === 0 ? n.toLocaleString() : n.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
    })()
  );
  const [duration, setDuration] = useState(
    initial.duration ?? initial.Duration ?? ""
  );
  const [monthlyFee, setMonthlyFee] = useState(
    (() => {
      const v = initial.monthlyFee ?? initial.MonthlyFee ?? initial.monthly ?? "";
      if (v === null || v === undefined || v === "") return "";
      const s = String(v).replace(/,/g, "");
      const n = Number(s);
      if (Number.isNaN(n)) return String(v);
      return n % 1 === 0 ? n.toLocaleString() : n.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
    })()
  );
  const [monthlyFeeManuallyEdited, setMonthlyFeeManuallyEdited] = useState(
    Boolean(
      initial.monthlyFee ?? initial.MonthlyFee ?? initial.monthly ?? false
    )
  );
  const [feeError, setFeeError] = useState("");
  const [durationError, setDurationError] = useState("");
  const [monthlyFeeError, setMonthlyFeeError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const [formError, setFormError] = useState("");
  const [checking, setChecking] = useState(false);
  const [subjectCodeError, setSubjectCodeError] = useState("");
  const [codeManuallyEdited, setCodeManuallyEdited] = useState(
    Boolean(initial.subjectCode || initial.SubjectCode)
  );
  const [autoGeneratedCode, setAutoGeneratedCode] = useState("");

  // Course selection state (single course)
  const [courses, setCourses] = useState([]);
  const [courseId, setCourseId] = useState(
    (() => {
      if (Array.isArray(initial.CourseIDs) && initial.CourseIDs.length) return String(initial.CourseIDs[0]);
      if (Array.isArray(initial.courseIds) && initial.courseIds.length) return String(initial.courseIds[0]);
      if (initial.courseId !== undefined && initial.courseId !== null) return String(initial.courseId);
      if (initial.CourseId !== undefined && initial.CourseId !== null) return String(initial.CourseId);
      if (initial.CourseID !== undefined && initial.CourseID !== null) return String(initial.CourseID);
      return "";
    })()
  );
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [courseError, setCourseError] = useState("");
  const [showTeacherModal, setShowTeacherModal] = useState(false);
  const [selectedTeacherForCourse, setSelectedTeacherForCourse] = useState("");
  const [teacherError, setTeacherError] = useState("");
  const [showNewCourseModal, setShowNewCourseModal] = useState(false);
  const [creatingCourse, setCreatingCourse] = useState(false);
  const [courseCreateError, setCourseCreateError] = useState("");

  // When suffix > 1, appends a counter to resolve name collisions (e.g. WAT818-2)
  const generateSubjectCode = (subjectName = "", suffix = 1) => {
    const trimmed = subjectName.replace(/[^a-zA-Z]/g, "").toUpperCase();
    const prefix = trimmed.slice(0, 3);
    if (!prefix) return "";
    const hash = Array.from(subjectName).reduce(
      (acc, char, index) => acc + char.charCodeAt(0) * (index + 1),
      0
    );
    const numericPart = String(hash % 1000).padStart(3, "0");
    const base = `${prefix}${numericPart}`;
    return suffix > 1 ? `${base}${suffix}` : base;
  };

  // Returns a class code guaranteed to be unique among existingCodes
  const generateUniqueSubjectCode = (subjectName = "", existingCodes = new Set()) => {
    let suffix = 1;
    let code = generateSubjectCode(subjectName, suffix);
    while (existingCodes.has(code.toUpperCase()) && suffix < 999) {
      suffix += 1;
      code = generateSubjectCode(subjectName, suffix);
    }
    return code;
  };

  // helper: format numeric string with thousand separators, preserve up to 2 decimals
  const formatWithCommas = (value) => {
    if (value === null || value === undefined) return "";
    const s = String(value).trim();
    if (s === "") return "";
    const raw = s.replace(/,/g, "");
    // allow leading minus? fees should be non-negative so ignore minus
    const parts = raw.split(".");
    const intPart = parts[0].replace(/[^0-9]/g, "") || "0";
    const fracPart = parts[1] ? parts[1].replace(/[^0-9]/g, "").slice(0, 2) : "";
    const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fracPart ? `${intFormatted}.${fracPart}` : intFormatted;
  };

  // Fetch available courses on mount
  useEffect(() => {
    if (hideCourseField) return;
    let cancelled = false;
    setCoursesLoading(true);
    getAllCourses()
      .then((list) => {
        if (!cancelled) {
          setCourses(
            (list || []).map((c) => ({
              id: Number(c.id ?? c.CourseID ?? c.courseId ?? c.courseID ?? 0),
              name: c.name ?? c.CourseName ?? c.courseName ?? "",
              code: c.code ?? c.CourseCode ?? c.courseCode ?? "",
            })).filter((c) => c.id && c.name)
          );
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setCoursesLoading(false); });
    return () => { cancelled = true; };
  }, [hideCourseField]);



  const parseNumber = (formatted) => {
    if (formatted === null || formatted === undefined) return NaN;
    const raw = String(formatted).replace(/,/g, "").trim();
    if (raw === "") return NaN;
    return Number(raw);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setDescriptionError("");
    setSubjectCodeError("");
    setFeeError("");
    setDurationError("");
    setMonthlyFeeError("");
    const trimmedName = name.trim();
    const trimmedCode = subjectCode.trim();
    const trimmedDescription = description.trim();

    // Validate both fields and show both errors at once if missing
    let hasError = false;
    if (!trimmedName) {
      setFormError("Class name is required");
      hasError = true;
    }
    if (!trimmedCode) {
      setSubjectCodeError("Class code is required");
      hasError = true;
    }
    // enforce format: uppercase alnum, dash or underscore, 2-20 chars
    if (trimmedCode && !/^[A-Z0-9_-]{2,20}$/.test(trimmedCode)) {
      setSubjectCodeError(
        "Class code must be 2–20 alphanumeric characters (no spaces)"
      );
      hasError = true;
    }
    if (trimmedDescription.length > 500) {
      setDescriptionError("Description must be 500 characters or less.");
      hasError = true;
    }

    // Require numeric fields: fee, duration, monthlyFee
    const feeRawTrim = String(fee || "").toString().trim().replace(/,/g, "");
    if (!feeRawTrim) {
      setFeeError("Subject fee is required");
      hasError = true;
    } else {
      const num = Number(feeRawTrim);
      if (Number.isNaN(num) || num < 0) {
        setFeeError("Subject fee must be a non-negative number.");
        hasError = true;
      }
    }

    const monthlyRawTrim = String(monthlyFee || "").toString().trim().replace(/,/g, "");
    if (!monthlyRawTrim) {
      setMonthlyFeeError("Monthly fee is required");
      hasError = true;
    } else {
      const num = Number(monthlyRawTrim);
      if (Number.isNaN(num) || num < 0) {
        setMonthlyFeeError("Monthly fee must be a non-negative number.");
        hasError = true;
      }
    }

    const parsedDuration = String(duration || "").toString().trim();
    if (!parsedDuration) {
      setDurationError("Duration is required");
      hasError = true;
    } else {
      // allow numbers or short text like "3 months"; if numeric, ensure positive
      const asNum = Number(parsedDuration);
      if (!Number.isNaN(asNum) && asNum <= 0) {
        setDurationError("Duration must be greater than zero.");
        hasError = true;
      }
    }

    if (!hideCourseField && !courseId) {
      setCourseError("Course is required");
      hasError = true;
    }

    if (hasError) return;

    // build payload including both common keys to improve backend compatibility
    const payload = {
      // include id when editing (cover multiple naming conventions)
      ...(subjectId
        ? {
            id: subjectId,
            SubjectID: subjectId,
            subjectId: subjectId,
          }
        : {}),
      name: trimmedName,
      subjectName: trimmedName,
      SubjectName: trimmedName,
      subjectCode: trimmedCode,
      SubjectCode: trimmedCode,
      description: trimmedDescription,
      Description: trimmedDescription,
      // optional financial/duration fields
      ...(String(fee || "").trim()
        ? {
            fee: Number(String(fee).trim().replace(/,/g, "")),
            Fee: Number(String(fee).trim().replace(/,/g, "")),
            subjectFee: Number(String(fee).trim().replace(/,/g, "")),
            SubjectFee: Number(String(fee).trim().replace(/,/g, "")),
          }
        : {}),
      ...(String(monthlyFee || "").trim()
        ? {
            monthlyFee: Number(String(monthlyFee).trim().replace(/,/g, "")),
            MonthlyFee: Number(String(monthlyFee).trim().replace(/,/g, "")),
          }
        : {}),
      ...(String(duration || "").trim()
        ? {
            duration: String(duration).trim(),
            Duration: String(duration).trim(),
          }
        : {}),
      // include courseName if provided initially so duplicate checks can scope to a course
      ...(initial.courseName
        ? {
            courseName: initial.courseName,
            CourseName: initial.courseName,
          }
        : {}),
      // include selected course in the payload
      ...(courseId
        ? {
            CourseID: Number(courseId),
            courseId: Number(courseId),
            CourseIDs: [Number(courseId)],
            courseIds: [Number(courseId)],
          }
        : {}),
    };

    // Prevent adding the same subject to the same course
    setChecking(true);
    try {
      const subjects = await getAllSubjects();
      const lowerName = trimmedName.toLowerCase();
      const courseName = (initial.courseName || "")
        .toString()
        .trim()
        .toLowerCase();

      const lowerCode = trimmedCode.toLowerCase();
      const duplicate = subjects.find((s) => {
        const sName = (s.name || s.subjectName || "")
          .toString()
          .trim()
          .toLowerCase();
        const sCode = (s.code || s.subjectCode || "")
          .toString()
          .trim()
          .toLowerCase();
        const sCourse = (s.courseName || "").toString().trim().toLowerCase();
        // consider duplicate if name or code matches within same course scope (if provided)
        if (courseName) {
          return (
            (sName === lowerName && sCourse === courseName) ||
            (sCode && sCode === lowerCode && sCourse === courseName)
          );
        }
        return sName === lowerName || (sCode && sCode === lowerCode);
      });

      if (duplicate) {
        // allow edit of the same record (same id)
        const dupId =
          duplicate.id ?? duplicate.SubjectID ?? duplicate.subjectId ?? "";
        if (subjectId && String(dupId) === String(subjectId)) {
          // it's the same record; allow
        } else {
          // prefer a code-specific message if codes match
          const dupCode = (duplicate.code ?? duplicate.subjectCode ?? "")
            .toString()
            .trim()
            .toLowerCase();
          if (dupCode && dupCode === trimmedCode.toLowerCase()) {
            setFormError(
              courseName
                ? "A class with this code already exists for the selected course."
                : "A class with this code already exists."
            );
          } else {
            setFormError(
              courseName
                ? "This class already exists for the selected course."
                : "A class with this name already exists."
            );
          }
          setChecking(false);
          return;
        }
      }
    } catch (err) {
      // If subject list fetch fails, allow submission but warn in console
      console.warn("Could not validate duplicates from backend:", err);
    } finally {
      setChecking(false);
    }

    onSubmit(payload);
  };

  useEffect(() => {
    if (initial.subjectCode || initial.SubjectCode) {
      setCodeManuallyEdited(true);
      return;
    }
    if (codeManuallyEdited) return;
    if (!name) {
      if (autoGeneratedCode) {
        setAutoGeneratedCode("");
        setSubjectCode("");
      }
      return;
    }

    let cancelled = false;
    const run = async () => {
      try {
        const existing = await getAllSubjectsIncludingInactive();
        if (cancelled) return;
        // Build a set of all codes already in use (exclude the subject being edited)
        const existingCodes = new Set(
          (existing || []).flatMap((s) => {
            const id = s.id ?? s.SubjectID ?? s.subjectId ?? null;
            if (subjectId && String(id) === String(subjectId)) return [];
            const raw = s.subjectCode ?? s.SubjectCode ?? s.code ?? "";
            return raw ? [String(raw).trim().toUpperCase()] : [];
          })
        );
        const generated = generateUniqueSubjectCode(name, existingCodes);
        if (!generated || generated === autoGeneratedCode) return;
        setAutoGeneratedCode(generated);
        setSubjectCode(generated);
      } catch (_) {
        // Fallback: simple generation without uniqueness check
        const generated = generateSubjectCode(name);
        if (!generated || generated === autoGeneratedCode) return;
        setAutoGeneratedCode(generated);
        setSubjectCode(generated);
      }
    };

    run();
    return () => { cancelled = true; };
  }, [
    name,
    codeManuallyEdited,
    autoGeneratedCode,
    initial.subjectCode,
    initial.SubjectCode,
    subjectId,
  ]);

  // Auto-calculate monthlyFee = fee / duration when possible
  useEffect(() => {
    if (monthlyFeeManuallyEdited) return;

    // parse fee as number (allow formatted input like "2,000")
    const feeRaw = String(fee ?? "").trim().replace(/,/g, "");
    const feeNum = Number(feeRaw);
    if (Number.isNaN(feeNum) || feeNum === 0) return;

    // extract first numeric value from duration (e.g. "3 months" -> 3)
    const durRaw = String(duration ?? "").trim();
    if (!durRaw) return;
    const match = durRaw.match(/-?\d+(?:\.\d+)?/);
    const durNum = match ? Number(match[0]) : Number(durRaw);
    if (Number.isNaN(durNum) || durNum <= 0) return;

    const monthly = feeNum / durNum;
    const rounded = Math.round(monthly * 100) / 100; // two decimals
    const display = Number.isInteger(rounded)
      ? String(rounded)
      : rounded.toFixed(2);
    // format auto-calculated monthly fee with thousand separators
    setMonthlyFee(formatWithCommas(display));
  }, [fee, duration, monthlyFeeManuallyEdited]);


  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      {step ? (
        <div className="text-sm font-medium text-indigo-600">
          Step {step} of 2
        </div>
      ) : null}

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Class Code <span className="text-red-500">*</span>
        </label>
        <input
          disabled
          value={subjectCode}
          onChange={(e) => {
            // normalize to uppercase and clear code errors
            const upper = String(e.target.value || "")
              .toUpperCase()
              .replace(/\s+/g, "");
            setSubjectCode(upper);
            setSubjectCodeError("");
            setCodeManuallyEdited(true);
          }}
          placeholder="e.g. WAT818"
          className="mt-1 block w-full rounded-md dark:bg-gray-700  border-gray-300 p-2"
        />
        {subjectCodeError ? (
          <p className="mt-1 text-sm text-red-600">{subjectCodeError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Class Name <span className="text-red-500">*</span>
        </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Wattala Class-Mon"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {formError ? (
          <p className="mt-1 text-sm text-red-600">{formError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Description
        </label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
          placeholder="Brief description (optional)"
        />
        {descriptionError ? (
          <p className="mt-1 text-sm text-red-600">{descriptionError}</p>
        ) : null}
      </div>

      {!hideCourseField && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Course <span className="text-red-500">*</span>
            </label>
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0">
                {coursesLoading ? (
                  <p className="text-sm text-gray-400">Loading courses…</p>
                ) : (
                  <CustomSelect
                    value={courseId}
                    onChange={(val) => {
                      setCourseId(val);
                      setCourseError("");
                    }}
                    options={courses.map((c) => ({
                      value: c.id,
                      label: c.code ? `${c.name} (${c.code})` : c.name,
                    }))}
                    placeholder={courses.length === 0 ? "No courses — add one →" : "-- Select Course --"}
                    searchPlaceholder="Search course..."
                    error={Boolean(courseError)}
                  />
                )}
              </div>
              <button
                type="button"
                title="Add new course"
                onClick={() => {
                  setSelectedTeacherForCourse("");
                  setTeacherError("");
                  setCourseCreateError("");
                  setShowTeacherModal(true);
                }}
                className="flex-shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:border-indigo-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors text-lg font-semibold leading-none"
              >
                +
              </button>
            </div>
            {courseError ? (
              <p className="mt-1 text-sm text-red-600">{courseError}</p>
            ) : null}
          </div>

          {/* Step 1: Assign Teacher Modal */}
          <Modal
            isOpen={showTeacherModal}
            size="lg"
            onClose={() => {
              setShowTeacherModal(false);
              setSelectedTeacherForCourse("");
              setTeacherError("");
            }}
            title={
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="p-2 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex-shrink-0">
                  <FiUsers className="text-white text-lg sm:text-xl" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 dark:text-white truncate">
                    Assign Teacher to Course
                  </h3>
                  <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                    Step 1 of 2: Select a teacher for <br />the new course
                  </p>
                </div>
              </div>
            }
          >
            <div className="space-y-4">
              <div className="bg-blue-50/80 dark:bg-blue-950/30 border border-blue-100 dark:border-blue-900/40 rounded-lg px-3 py-2 text-xs text-blue-700 dark:text-blue-300">
                Select a teacher who will be responsible for this course.
              </div>

              <div>
                <label className="block mb-1.5 text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Select Teacher <span className="text-red-500">*</span>
                </label>
                <TeacherPicker
                  value={selectedTeacherForCourse}
                  onChange={(val) => {
                    setSelectedTeacherForCourse(val ?? "");
                    setTeacherError("");
                  }}
                  showRefresh={true}
                  inlineDropdown={true}
                  className="border-2 border-blue-100 dark:border-blue-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 rounded-xl"
                />
                {teacherError ? (
                  <p className="mt-1 text-xs sm:text-sm text-red-600 dark:text-red-400">{teacherError}</p>
                ) : null}
              </div>

              <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => {
                    setShowTeacherModal(false);
                    setSelectedTeacherForCourse("");
                    setTeacherError("");
                  }}
                  className="w-full sm:w-auto justify-center px-5"
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  variant="primary"
                  onClick={() => {
                    if (!selectedTeacherForCourse) {
                      setTeacherError("Please select a teacher to continue.");
                      return;
                    }
                    setShowTeacherModal(false);
                    setCourseCreateError("");
                    setShowNewCourseModal(true);
                  }}
                  disabled={!selectedTeacherForCourse}
                  className="w-full sm:w-auto justify-center px-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-md"
                >
                  <span className="flex items-center justify-center gap-2">
                    Continue
                    <FiChevronRight className="w-4 h-4" />
                  </span>
                </Button>
              </div>
            </div>
          </Modal>

          {/* Step 2: Add New Course Modal */}
          <Modal
            isOpen={showNewCourseModal}
            size="lg"
            onClose={() => {
              if (!creatingCourse) {
                setShowNewCourseModal(false);
                setSelectedTeacherForCourse("");
              }
            }}
            title={
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="p-2 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-lg flex-shrink-0">
                  <FiBook className="text-white text-lg sm:text-xl" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 dark:text-white truncate">
                    Add New Course
                  </h3>
                  <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                    Step 2 of 2: Fill in course details
                  </p>
                </div>
              </div>
            }
          >
            {courseCreateError ? (
              <div className="mb-4 p-3 rounded-md bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-sm text-red-600 dark:text-red-300">
                {courseCreateError}
              </div>
            ) : null}
            <CourseForm
              loading={creatingCourse}
              hideAssignTeacher={true}
              hideClasses={true}
              initialData={{
                teacherId: selectedTeacherForCourse || "",
              }}
              onSubmit={async (data) => {
                setCreatingCourse(true);
                setCourseCreateError("");
                try {
                  const numericTeacherId = Number(selectedTeacherForCourse);
                  const teacherVal =
                    !Number.isNaN(numericTeacherId) && numericTeacherId
                      ? numericTeacherId
                      : selectedTeacherForCourse || undefined;

                  const payload = {
                    ...data,
                    teacherId: teacherVal,
                    TeacherID: teacherVal,
                  };

                  const newCourse = await createCourse(payload);
                  const newId = Number(
                    newCourse?.id ?? newCourse?.CourseID ?? newCourse?.CourseId ?? newCourse?.courseId ?? 0
                  );
                  const newName =
                    newCourse?.name ?? newCourse?.CourseName ?? newCourse?.courseName ?? data.name ?? "";
                  const newCode =
                    newCourse?.code ?? newCourse?.CourseCode ?? newCourse?.courseCode ?? data.code ?? "";
                  if (newId) {
                    const entry = { id: newId, name: newName, code: newCode };
                    setCourses((prev) => [...prev, entry]);
                    setCourseId(String(newId));
                    setCourseError("");
                  }
                  setShowNewCourseModal(false);
                  setSelectedTeacherForCourse("");
                } catch (err) {
                  console.error("Failed to create course:", err);
                  const msg =
                    err?.response?.data?.message ||
                    err?.response?.data?.title ||
                    err?.message ||
                    "Failed to create course. Please try again.";
                  setCourseCreateError(msg);
                } finally {
                  setCreatingCourse(false);
                }
              }}
              onCancel={() => {
                setShowNewCourseModal(false);
                setShowTeacherModal(true);
              }}
            />
          </Modal>
        </>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Subject Fee <span className="text-red-500">*</span>
        </label>
        <input
          value={fee}
          onChange={(e) => {
            const raw = String(e.target.value || "").replace(/,/g, "");
            // keep only digits and optional decimal
            const sanitized = raw.replace(/[^0-9.]/g, "");
            // ensure single decimal point
            const parts = sanitized.split(".");
            const intPart = parts[0] || "";
            const frac = parts[1] ? parts[1].slice(0, 2) : "";
            const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const formatted = frac ? `${formattedInt}.${frac}` : formattedInt;
            setFee(formatted);
            setFeeError("");
          }}
          placeholder="e.g. 2,000"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {feeError ? (
          <p className="mt-1 text-sm text-red-600">{feeError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Duration(Months) <span className="text-red-500">*</span>
        </label>
        <input
          value={duration}
          onChange={(e) => {
            setDuration(e.target.value);
            setDurationError("");
          }}
          placeholder="e.g. 3 months or 12"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {durationError ? (
          <p className="mt-1 text-sm text-red-600">{durationError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Monthly Fee <span className="text-red-500">*</span>
        </label>
        <input
          value={monthlyFee}
          onChange={(e) => {
            const raw = String(e.target.value || "").replace(/,/g, "");
            const sanitized = raw.replace(/[^0-9.]/g, "");
            const parts = sanitized.split(".");
            const intPart = parts[0] || "";
            const frac = parts[1] ? parts[1].slice(0, 2) : "";
            const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const formatted = frac ? `${formattedInt}.${frac}` : formattedInt;
            setMonthlyFee(formatted);
            setMonthlyFeeManuallyEdited(true);
            setMonthlyFeeError("");
          }}
          placeholder="e.g. 250"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {monthlyFeeError ? (
          <p className="mt-1 text-sm text-red-600">{monthlyFeeError}</p>
        ) : null}
      </div>

      

      <div className="flex flex-wrap justify-end gap-2">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={loading || checking}
        >
          Cancel
        </Button>
        <Button type="button" variant="primary" disabled={loading || checking} onClick={handleSubmit}>
          {loading || checking ? "Saving..." : "Save"}
        </Button>
      </div>
    </form>
  );
};

export default SubjectForm;
